import { FC, Fragment, useState } from 'react';
import ProductHeader from '../ProductHeader';
import CommonCardA from '../CommonCardA';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useProductList } from '@/components/MembersDay/utils';
import { IProductProps, ProductModule } from '@/components/MembersDay/type';
import ViewMore from '@/components/MembersDay/FY2024/ActivityCom/ViewMore';
import { NA_SITES } from '@/constants/membersday';

const BestSellers: FC<IProductProps> = ({ module, icon, title, desc, id = 'activity-BestSellers' }) => {
    const { locale } = getLocal();
    const { productList } = useProductList(module, locale);
    const isShowMoreBtn = NA_SITES.includes(locale) && module !== ProductModule.BEST_SELLERS2;
    const [hideMore, setHideMore] = useState(!isShowMoreBtn); // 默认展开

    return (
        <div className={`${styled.BestSellers} ${hideMore ? 'hide-more-view' : ''}`} id={id}>
            <ProductHeader icon={icon} title={title} desc={desc} />
            <div className={`members-day-inter`}>
                {productList
                    .filter((_item, index) => (isShowMoreBtn && hideMore ? index < 6 : true))
                    .map((item, index: number) => {
                        return (
                            <Fragment key={index}>
                                <CommonCardA data={item} list_name={title} module={module} />
                            </Fragment>
                        );
                    })}
            </div>
            {isShowMoreBtn && (
                <ViewMore
                    isViewMore={true}
                    callback={() => {
                        setHideMore(!hideMore);
                    }}
                    hideMore={hideMore}
                />
            )}
        </div>
    );
};

export default BestSellers;
